import React, { useEffect } from 'react'

export default function Lightbox({ open, src, title, onClose }) {
  useEffect(() => {
    if (!open) return
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null
  const isPdf = /\.pdf($|\?)/i.test(src || '')
  return (
    <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center'}} onClick={onClose}>
      <div className="card" style={{maxWidth:'95vw', maxHeight:'95vh', width:'fit-content', padding:0}} onClick={(e)=>e.stopPropagation()}>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 12px', borderBottom:'1px solid var(--border)'}}>
          <div className="muted" style={{fontWeight:600}}>{title || 'Preview'}</div>
          <div style={{display:'flex', gap:8}}>
            <a className="btn btn-secondary" href={src} target="_blank" rel="noreferrer">Open in new tab</a>
            <button className="btn" onClick={onClose} aria-label="Close">×</button>
          </div>
        </div>
        <div style={{padding:12}}>
          {isPdf ? (
            <iframe src={src} title={title || 'PDF'} style={{width:'80vw', height:'80vh', border:'none', borderRadius:8}} />
          ) : (
            <img src={src} alt={title || 'Preview'} style={{maxWidth:'80vw', maxHeight:'80vh', borderRadius:8}} />
          )}
        </div>
      </div>
    </div>
  )
}

